module.exports = __webpack_public_path__ + "static/media/icon-insatisfeito.28072326.svg";